<template>

  <ion-grid>
    <ion-row>
      <ion-col>
        <h2>Testimonies</h2>
      </ion-col>
    </ion-row>
    <ion-row >
      <ion-col v-for="(testimony, index) in testimonies" :key="index">
        <Testimony
        :name="testimony.name"
        :image="testimony.image"
        :comment="testimony.comment"
        :jobTitle="testimony.jobTitle"
        :company="testimony.company"
        />
      </ion-col>
     </ion-row>
  </ion-grid>

</template>
<script>

import { IonRow, IonCol, IonGrid } from '@ionic/vue';
import Testimony from './Testimony.vue';

export default {
  name: 'Testimonies',
  components: {
    IonRow, IonCol, Testimony, IonGrid
  },
  data() {
    return {
      testimonies: [
        {
          name: "Hongxuan (Will) Zhang",
          image: "https://media.licdn.com/dms/image/D5603AQE8etgq3B9iNA/profile-displayphoto-shrink_200_200/0/1669509465910?e=1678924800&v=beta&t=cUE8w4tCSsY0QrJV-xQKOl8xmx2HZmJIDAjADKoRRvw",
          comment: "Edward is a great asset to have. He's super flexible in terms of handling the changes in project priority and has broad knowledge spreading from data science model development, analytics, to ML engineering. He's been an excellent communicator and easy to work with.",
          jobTitle: "Head of Data",
          company: "Level"
        },
        {
          name: "Mike Arnett",
          image: "https://media.licdn.com/dms/image/C5103AQFllXxqW1P65A/profile-displayphoto-shrink_200_200/0/1516292101566?e=1678924800&v=beta&t=zF1FEUbInpexDzoz9LNBjJ3e1mxIxM71nLqtwNzUlK0",
          comment: "I enjoyed and benefited greatly from working with Ed Turner on our Sas Analyzer that he helped us to build in Python. Ed is not only a great Python developer, he is also a great Agile developer and he helped to keep us on task in Jira. Finally, Ed is a conscientious and deliberate Python coder that I think would make a great addition to any team.",
          jobTitle: "Chief Executive Offier",
          company: "BNL Consulting"
        },
        {
          name: "Edward Murphy",
          image: "https://media.licdn.com/dms/image/C4D03AQETuFG4_p5u8Q/profile-displayphoto-shrink_200_200/0/1517065104214?e=1678924800&v=beta&t=8XmI33cmrrJTAnotsYU7AbErsyuady92n9lpAYhK06U",
          comment: "Working with Edward was a pleasure. His approach always balances the three key aspects of successful data science: business focus, technology leadership, and statistical practice. His work on a key process led to faster turnaround times, better maintainability, and far greater resiliency overall.",
          jobTitle: "Head of Data Science",
          company: "1010data"
        }
      ]
    }
  }
}
</script>
